
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={scrollToTop}>
            <img 
              src="https://static.readdy.ai/image/04bffda83af79335128d062f8508dd8e/996d98ec8efcd8c3f64e63d4ed98aa66.png" 
              alt="Hydrogen Technology Logo" 
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Home
            </button>
            <button onClick={() => scrollToSection('technology')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Technology
            </button>
            <button onClick={() => scrollToSection('why-us')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Why Us
            </button>
            <button onClick={() => scrollToSection('applications')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Applications
            </button>
            <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              About
            </button>
            <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-teal-600 transition-colors font-medium cursor-pointer">
              Contact
            </button>
          </div>

          <button className="md:hidden text-gray-700 cursor-pointer">
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>
    </nav>
  );
}
